import { render, staticRenderFns } from "./NavigationMenuClick.vue?vue&type=template&id=67fba0b6&scoped=true&"
import script from "./NavigationMenuClick.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuClick.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenuClick.vue?vue&type=style&index=0&id=67fba0b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fba0b6",
  null
  
)

export default component.exports